import React from 'react';
import { Input } from '../../../../shared/components/Input';
import { SectionProps } from '../../types';

export const CustomerSection: React.FC<SectionProps> = ({ formData, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-medium font-heading text-blueprint-blue mb-6">Customer Information</h3>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Customer Name
            </label>
            <Input
              type="text"
              name="customerName"
              value={formData.customerName}
              onChange={onChange}
              placeholder="Enter customer name"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Project Title
            </label>
            <Input
              type="text"
              name="projectTitle"
              value={formData.projectTitle}
              onChange={onChange}
              placeholder="Enter project title"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Customer Contact Person
            </label>
            <Input
              type="text"
              name="customerAttn"
              value={formData.customerAttn}
              onChange={onChange}
              placeholder="Enter contact person name"
            />
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-medium font-heading text-blueprint-blue mb-6">Contact Details</h3>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Email Address
            </label>
            <Input
              type="email"
              name="customerEmail"
              value={formData.customerEmail}
              onChange={onChange}
              placeholder="Enter email address"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Phone Number
            </label>
            <Input
              type="tel"
              name="customerPhone"
              value={formData.customerPhone}
              onChange={onChange}
              placeholder="Enter phone number"
            />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-text-grey mb-2">
              Address Line 1
            </label>
            <Input
              type="text"
              name="customerAddressLine1"
              value={formData.customerAddressLine1}
              onChange={onChange}
              placeholder="Enter street address"
            />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-text-grey mb-2">
              Address Line 2
            </label>
            <Input
              type="text"
              name="customerAddressLine2"
              value={formData.customerAddressLine2}
              onChange={onChange}
              placeholder="Enter apartment, suite, etc."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              City
            </label>
            <Input
              type="text"
              name="customerCity"
              value={formData.customerCity}
              onChange={onChange}
              placeholder="Enter city"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              State / Province
            </label>
            <Input
              type="text"
              name="customerState"
              value={formData.customerState}
              onChange={onChange}
              placeholder="Enter state/province"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Postal Code
            </label>
            <Input
              type="text"
              name="customerPostalCode"
              value={formData.customerPostalCode}
              onChange={onChange}
              placeholder="Enter postal code"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Country
            </label>
            <Input
              type="text"
              name="customerCountry"
              value={formData.customerCountry}
              onChange={onChange}
              placeholder="Enter country"
            />
          </div>
        </div>
      </div>
    </div>
  );
}; 